<template>
  <VView class="quiz-end" back-button-to="/menu" header="Wynik">
     <VText center biggest>{{ score }}/10</VText>

     <VText center>{{ result }}</VText>

     <VBlock max-width="460px">
      <transition name="bounceUp" appear>
        <VButton to="/menu">Powrót</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'QuizEnd',

  computed: {
    score() {
      return this.$route.query.score || 0;
    },

    result() {
      switch (this.score) {
        case '1': return '"Oh... My... God!" Wygląda na to, że Janice wie więcej o Przyjaciołach niż Ty!'
        case '2': return 'Czy oglądałeś właściwy serial? Zapraszamy na powtórkę z Przyjaciół na Comedy Central!'
        case '3': return 'Chyba przysnąłeś podczas seansu. Może czas nadrobić kilka odcinków z Comedy Central?'
        case '4': return 'Jak Ross w zagadnieniach miłosnych. Blisko, ale nie do końca... Odpalaj Comedy Central i nadrób zaległości!'
        case '5': return 'Jesteś w połowie drogi! Tak jak Joey z encyklopedią - trochę wiesz, ale jeszcze nie wszystko.'
        case '6': return 'Nieźle, ale mogłoby być lepiej. To prawie jak z wyprowadzaniem kanapy Rossa – Pivot! Pivot!'
        case '7': return 'Ross byłby z Ciebie dumny! Wiesz całkiem sporo, ale zawsze można lepiej!'
        case '8': return 'Monica byłaby zachwycona! Świetna robota, prawie perfekcyjnie!'
        case '9': return 'Chandler by powiedział: "Could you BE any better?"". Zabrakło jednego punktu do pełni chwały!'
        case '10': return ' Jesteś mistrzem! Joey pyta: "How you doin’?" bo właśnie zostałeś ekspertem od Przyjaciół!'

        default: return '"Oh... My... God!" Wygląda na to, że Janice wie więcej o Przyjaciołach niż Ty!'
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.quiz-end {

}
</style>
